import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as state from '../../../../../../../../state'

/**
 * Shows the root {@link state.summit.allocations.models.Outcome}
 */
@ngCore.Component({
  selector: 'atn-summit-allocation-graph-root-outcome',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * {@link state.summit.allocations.models.Outcome} to display in this overlay {@link Component}
   */
  public readonly outcomeSg =
    ngCore.input.required<state.summit.allocations.models.Outcome>({
      alias: 'outcome',
    })

  /**
   * Emitted when the user clicks the link to navigate to the outcome explore page
   */
  public readonly linkClicked = ngCore.output<{
    entityId: ents.core.dms.models.Entity.Id
    recordId: ents.core.dms.data.Record.Id
  }>()

  /**
   * Handles the link click and emits the navigation event
   */
  public onLinkClick(event: {
    entityId: ents.core.dms.models.Entity.Id
    recordId: ents.core.dms.data.Record.Id
  }): void {
    this.linkClicked.emit(event)
  }
}
